import { getTypedState } from 'ducks/hooks'
import { Estimate, EstimateContact, EstimateProperties } from 'ducks/types'
import { EstimateType } from './types'

export const getEstimate = () => (): EstimateType | null => {
  const { estimate } = getTypedState()
  return estimate ?? null
}

export const isEstimateServiceable = () => (): boolean => {
  const estimate = getTypedState().estimate as Estimate | null
  return estimate?.properties?.territory?.serviceable || false
}

export const getEstimateProperties = () => (): Partial<EstimateProperties> | null => {
  const estimate = getTypedState().estimate as Estimate | null
  return estimate?.properties ?? null
}

export const getContactInEstimate = (userEmail: string) => (): Partial<EstimateContact> | null => {
  const estimate = getTypedState().estimate as Estimate | null
  return estimate?.properties?.contacts?.find(c => c.email === userEmail) ?? null
}

export const getContactIndexInEstimate = (userEmail: string) => (): number => {
  const estimate = getTypedState().estimate as Estimate | null
  return estimate?.properties?.contacts?.findIndex(c => c.email === userEmail) ?? -1
}